class Clock {
  nowInMilliseconds (): number {
    return (new Date()).getTime()
  }
  nowInSeconds (): number {
    return (new Date()).getTime() / 1000
  }
}

const clock = new Clock()
export default clock